import { render, staticRenderFns } from "./ZhenYunServiceAgreement.vue?vue&type=template&id=3b1e1978&scoped=true"
import script from "./ZhenYunServiceAgreement.vue?vue&type=script&lang=js"
export * from "./ZhenYunServiceAgreement.vue?vue&type=script&lang=js"
import style0 from "./ZhenYunServiceAgreement.vue?vue&type=style&index=0&id=3b1e1978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e1978",
  null
  
)

export default component.exports